<template>
    <transition-group
        tag="div"
        name="animation-list__drop-in-"
        class="betslip__system-box"
    >
        <div
            v-for="system in systems"
            :key="system.id"
            class="betslip__system-combinations"
        >
            <input
                :id="'inlineCheckbox' + system.id"
                class="checkbox"
                type="checkbox"
                :checked="system.isSelected"
                @click="onClick(system)"
            >
            <label
                :for="'inlineCheckbox' + system.id"
                class="form-check-label"
            >
                <span class="form-check-label__text">
                    {{ systemName(system) }}
                </span>
            </label>
        </div>
    </transition-group>
</template>

<script>
    export default {
        name: 'LottoSystems',
        props: {
            systems: {
                type: Array,
                required: true
            },
        },
        computed: {
            systemName() {
                return (system) => (`${system.name}(${system.combinationCount})`);
            }
        },
        methods: {
            onClick(system) {
                this.$emit('systemClick', system);
            }
        }
    };
</script>

<style scoped>
    .lotto-systems {
        display: flex;
        flex-wrap: wrap;
    }
    .lotto-systems>div {
        flex: 0 50%;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/shared/lotto/betSlip/LottoSystems.vue